import type { CategoryItem } from '~/types/root'

// The CMS gives every category node a distinct 36-character GUID, and the page payload
// carries the whole tree. After compression the GUIDs are most of its size (~5 KB of a
// ~35 KB gzipped PDP), yet the app only uses them as keys. The first 8 hex digits are unique
// in practice; a prefix that repeats keeps the full id. A short id is only as stable as its
// GUID: the backend can reissue GUIDs between fetches, so state keyed by id (an open
// submenu) is not guaranteed to survive a refetch.
const ID_LENGTH = 8

export const shortenCategoryIds = (categories: CategoryItem[]): CategoryItem[] => {
  const used = new Set<string>()
  const shorten = (items: CategoryItem[]): CategoryItem[] => items.map((item) => {
    const prefix = item.id?.slice(0, ID_LENGTH)
    const id = prefix && !used.has(prefix) ? prefix : item.id
    used.add(id)
    return item.children ? { ...item, id, children: shorten(item.children) } : { ...item, id }
  })
  return shorten(categories)
}
